import React, { useState } from "react";

function DragAndDropIndex({ data, renderRow, updateIndexFolder }) {
    const [draggedIndex, setDraggedIndex] = useState(null);

    const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    const handleDrop = (e, targetIndex) => {
        e.preventDefault();
        if (draggedIndex === null || draggedIndex === targetIndex) return;

        // Swap elements for horizontal ordering
        const updatedData = [...data];
        const [movedItem] = updatedData.splice(draggedIndex, 1);
        updatedData.splice(targetIndex, 0, movedItem);

        setDraggedIndex(null);
        updateIndexFolder(updatedData); // Update parent component
    };

    return data && data.length > 0 ? (
        <tbody>
            {data.map((item, index) => (
                <tr
                    key={item.id}
                    draggable={item.id > 0 ? "true" : "false"}
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={(e) => handleDragOver(e)}
                    onDrop={(e) => handleDrop(e, index)}
                    style={{
                        cursor: "grab",
                        opacity: draggedIndex === index ? "0.3" : "1",
                    }}
                >
                    {renderRow(item, index)}
                </tr>
            ))}
        </tbody>
    ) : (
        <p className="text-center">Không có dữ liệu!</p>
    );
}

export default DragAndDropIndex;
